import { getContactId, setContactId } from '../utils/contactId';
import React, { useEffect, useRef, useState } from "react";
import Autocomplete from "react-google-autocomplete";
import * as googleMapreact from "google-map-react";
import { FaLock } from "react-icons/fa6";
import { IoLocationOutline } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { sendEmail } from '../Api/Email';
import { AdsKeys } from '../Api/Constants';
import Modal from "./Modal";
import { useExperimentWithExposureLoggingDisabled, Statsig } from 'statsig-react';
import brandConfig, { withPreviewBrand } from '../config/brand';
import {
  EXPERIMENTS,
  EVENTS,
  trackEvent,
  resolveStep1CtaCopy,
  getStatsigStableId,
} from '../utils/statsig';
import { getQuoteSession } from '../utils/serviceOptions';
import { publishSplitAssignment, requestSplitAssignment, splitAddressFromPlace } from '../utils/splitTest';
import { eastBayBrand, eastBayFallbackAssignment } from '../utils/eastBayDirect';
console.log("googleMapreact", googleMapreact);
const center = {
  lat: 0,
  lng: 0,
};
const countryCodes = {
  "+1": "United States/Canada", "+7": "Russia/Kazakhstan", "+20": "Egypt", "+27": "South Africa", "+30": "Greece", "+31": "Netherlands", "+32": "Belgium", "+33": "France", "+34": "Spain", "+36": "Hungary", "+39": "Italy", "+40": "Romania", "+41": "Switzerland", "+43": "Austria", "+44": "United Kingdom", "+45": "Denmark", "+46": "Sweden", "+47": "Norway", "+48": "Poland", "+49": "Germany", "+51": "Peru", "+52": "Mexico", "+53": "Cuba", "+54": "Argentina", "+55": "Brazil", "+56": "Chile", "+57": "Colombia", "+58": "Venezuela", "+60": "Malaysia", "+61": "Australia", "+62": "Indonesia", "+63": "Philippines", "+64": "New Zealand", "+65": "Singapore", "+66": "Thailand", "+81": "Japan", "+82": "South Korea", "+84": "Vietnam", "+86": "China", "+90": "Turkey", "+91": "India", "+92": "Pakistan", "+93": "Afghanistan", "+94": "Sri Lanka", "+95": "Myanmar", "+98": "Iran", "+211": "South Sudan", "+212": "Morocco", "+213": "Algeria", "+216": "Tunisia", "+218": "Libya", "+220": "Gambia", "+221": "Senegal", "+222": "Mauritania", "+223": "Mali", "+224": "Guinea", "+225": "Ivory Coast", "+226": "Burkina Faso", "+227": "Niger", "+228": "Togo", "+229": "Benin", "+230": "Mauritius", "+231": "Liberia", "+232": "Sierra Leone", "+233": "Ghana", "+234": "Nigeria", "+235": "Chad", "+236": "Central African Republic", "+237": "Cameroon", "+238": "Cape Verde", "+239": "São Tomé and Príncipe", "+240": "Equatorial Guinea", "+241": "Gabon", "+242": "Congo", "+243": "Democratic Republic of the Congo", "+244": "Angola", "+245": "Guinea-Bissau", "+246": "British Indian Ocean Territory", "+248": "Seychelles", "+249": "Sudan", "+250": "Rwanda", "+251": "Ethiopia", "+252": "Somalia", "+253": "Djibouti", "+254": "Kenya", "+255": "Tanzania", "+256": "Uganda", "+257": "Burundi", "+258": "Mozambique", "+260": "Zambia", "+261": "Madagascar", "+262": "Réunion", "+263": "Zimbabwe", "+264": "Namibia", "+265": "Malawi", "+266": "Lesotho", "+267": "Botswana", "+268": "Eswatini", "+269": "Comoros", "+290": "Saint Helena", "+291": "Eritrea", "+297": "Aruba", "+298": "Faroe Islands", "+299": "Greenland", "+350": "Gibraltar", "+351": "Portugal", "+352": "Luxembourg", "+353": "Ireland", "+354": "Iceland", "+355": "Albania", "+356": "Malta", "+357": "Cyprus", "+358": "Finland", "+359": "Bulgaria", "+370": "Lithuania", "+371": "Latvia", "+372": "Estonia", "+373": "Moldova", "+374": "Armenia", "+375": "Belarus", "+376": "Andorra", "+377": "Monaco", "+378": "San Marino", "+380": "Ukraine", "+381": "Serbia", "+382": "Montenegro", "+383": "Kosovo", "+385": "Croatia", "+386": "Slovenia", "+387": "Bosnia and Herzegovina", "+389": "North Macedonia", "+420": "Czech Republic", "+421": "Slovakia", "+423": "Liechtenstein", "+500": "Falkland Islands", "+501": "Belize", "+502": "Guatemala", "+503": "El Salvador", "+504": "Honduras", "+505": "Nicaragua", "+506": "Costa Rica", "+507": "Panama", "+508": "Saint Pierre and Miquelon", "+509": "Haiti", "+590": "Guadeloupe", "+591": "Bolivia", "+592": "Guyana", "+593": "Ecuador", "+594": "French Guiana", "+595": "Paraguay", "+596": "Martinique", "+597": "Suriname", "+598": "Uruguay", "+599": "Curaçao/Bonaire", "+670": "East Timor", "+672": "Norfolk Island", "+673": "Brunei", "+674": "Nauru", "+675": "Papua New Guinea", "+676": "Tonga", "+677": "Solomon Islands", "+678": "Vanuatu", "+679": "Fiji", "+680": "Palau", "+681": "Wallis and Futuna", "+682": "Cook Islands", "+683": "Niue", "+685": "Samoa", "+686": "Kiribati", "+687": "New Caledonia", "+688": "Tuvalu", "+689": "French Polynesia", "+690": "Tokelau", "+691": "Micronesia", "+692": "Marshall Islands", "+850": "North Korea", "+852": "Hong Kong", "+853": "Macau", "+855": "Cambodia", "+856": "Laos", "+880": "Bangladesh", "+886": "Taiwan", "+960": "Maldives", "+961": "Lebanon", "+962": "Jordan", "+963": "Syria", "+964": "Iraq", "+965": "Kuwait", "+966": "Saudi Arabia", "+967": "Yemen", "+968": "Oman", "+971": "United Arab Emirates", "+972": "Israel", "+973": "Bahrain", "+974": "Qatar", "+975": "Bhutan", "+976": "Mongolia", "+977": "Nepal", "+992": "Tajikistan", "+993": "Turkmenistan", "+994": "Azerbaijan", "+995": "Georgia", "+996": "Kyrgyzstan", "+998": "Uzbekistan"
};

const detectCountryCode = (phoneNumber) => {
  for (const code in countryCodes) {
    const regex = new RegExp(`^\\${code}`);
    if (regex.test(phoneNumber)) {
      return code; // Return the country code
    }
  }
};

const formatPhoneNumber = (value) => {
  if (!value) return value;

  // Remove all non-digit characters
  const phoneNumber = value.replace(/[^\d+]/g, '');

  // Detect the country code
  detectCountryCode(phoneNumber);
  // No country code detected, format without it
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

// The marketing-site header hands off these keys (see the handleWindowLoad
// effect). Consuming a handoff means removing all of them together; a
// partial removal leaves the effect re-running a stale handoff on the next
// mount.
const clearHeaderHandoff = () => {
  ['address', 'name', 'phone', 'googlePlace', 'googlePlaceId', 'url_referrer']
    .forEach((key) => localStorage.removeItem(key));
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: -30,
    height: '70vh',
    width: '100vw',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loader: {
    position: 'relative',
    width: '100px',
    height: '100px',
  },
  ring: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100px',
    height: '100px',
    border: '5px solid #ccc',
    borderTop: '5px solid #007bff',
    borderRadius: '50%',
    animation: 'spinLoader 1s linear infinite',
  },
  icon: {
    width: '40px',
    height: '40px',
    position: 'absolute',
    top: '35px',
    left: '35px',
  },
};

const Slide1 = ({ initialData = {}, onNext }) => {
  const navigate = useNavigate();
  const { config: step1CtaExperiment } = useExperimentWithExposureLoggingDisabled(
    EXPERIMENTS.STEP1_CTA_COPY,
  );
  const step1CtaExposureLogged = useRef(false);
  const [selectedLocation, setSelectedLocation] = useState(center);
  const [inputValue, setInputValue] = useState(initialData.address || "");
  const [inputZipCodeValue, setInputZipCodeValue] = useState("");
  const [zipMissingFromPlace, setZipMissingFromPlace] = useState(false);
  const [isValidAddress, setIsValidAddress] = useState(true);
  const [isLoading, setIsLoading] = useState(!initialData.address && !(localStorage.getItem('address') === null || localStorage.getItem('address') === undefined || localStorage.getItem('address') === ''));
  const [errors, setErrors] = useState({});
  const [showErrors, setShowErrors] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [formData, setFormData] = useState({
    personName: '',
    phone: '',
    ...initialData,
  });
  const [isPhoneNumberExist, setIsPhoneNumberExist] = useState(false);

  const step1CtaCopy = resolveStep1CtaCopy({
    experimentCta: (step1CtaExperiment && step1CtaExperiment.get)
      ? step1CtaExperiment.get('cta', 'Next')
      : 'Next',
    brand: brandConfig.key,
    search: typeof window !== 'undefined' ? window.location.search : '',
    sessionStore: typeof sessionStorage !== 'undefined' ? sessionStorage : null,
  });

  useEffect(() => {
    try {
      const forced = new URLSearchParams(window.location.search).get('step1_cta');
      if (forced) sessionStorage.setItem('force_step1_cta', forced);
    } catch { /* ignore */ }
    if (brandConfig.key !== 'cabana' || step1CtaExposureLogged.current) return;
    step1CtaExposureLogged.current = true;
    try {
      Statsig.manuallyLogExperimentExposure(EXPERIMENTS.STEP1_CTA_COPY);
    } catch { /* Statsig may not be initialized in tests */ }
    trackEvent(EVENTS.STEP1_CTA_VARIANT_RENDERED, {
      cta: step1CtaCopy,
      brand: brandConfig.key,
    });
  }, [step1CtaCopy]);

  useEffect(() => {
    const handleWindowLoad = () => {
      if (localStorage.getItem('googlePlace')) {
        setIsLoading(true);
        if (localStorage.getItem('address') === "I can't find my address") {
          navigate(withPreviewBrand("/step/2"));
          clearHeaderHandoff();
        } else {
          const intervalId = setInterval(async () => {
            if (window.google && window.google.maps) {
              clearInterval(intervalId);
              const geocoder = new window.google.maps.Geocoder();
              const address = localStorage.getItem('address') || '';
              geocoder.geocode({ address }, async (results, status) => {
                if (status === "OK" && results[0]) {
                  const zipComponent = (results[0].address_components || []).find(component =>
                    (component.types || []).includes("postal_code")
                  );

                  // Same normalization as handlePlaceSelected: a raw
                  // long_name can be ZIP+4 or malformed, and feeding that
                  // to /api/allowed-zip returns a false out-of-area.
                  const zip = zipComponent?.long_name?.match(/\b\d{5}\b/)?.[0] || "";
                  let formatted = address;

                  // Check if ZIP already exists
                  const zipRegex = new RegExp(`\\b${zip}\\b`);

                  if (zip && !zipRegex.test(address)) {
                    // Find last comma index
                    const lastCommaIndex = address.lastIndexOf(',');

                    if (lastCommaIndex !== -1) {
                      // Insert ZIP before last comma
                      formatted = address.slice(0, lastCommaIndex) + ` ${zip}` + address.slice(lastCommaIndex);
                    } else {
                      // No comma found, just append ZIP
                      formatted = address + ` ${zip}`;
                    }
                  }
                  handlePlaceSelected(results[0]);
                  const location = results[0].geometry.location;
                  const lat = location.lat();
                  const lng = location.lng();
                  const zipCode = zip;
                  const savedName = localStorage.getItem('name') || '';
                  const savedPhone = localStorage.getItem('phone') || '';

                  // No ZIP from the geocode means the header address was a
                  // route- or city-level suggestion, not that the customer
                  // is out of area. Unknown must mean "ask": land them on
                  // this form with everything prefilled and the ZIP field
                  // showing (handlePlaceSelected above set
                  // zipMissingFromPlace). The old behavior sent real
                  // in-area leads (Rancho Santa Fe, Granite Bay) to the
                  // out-of-area experience.
                  if (!zipCode) {
                    setFormData({
                      personName: savedName,
                      phone: formatPhoneNumber(savedPhone),
                      address: formatted,
                      locationData: { lat, lng }
                    });
                    setInputValue(formatted);
                    clearHeaderHandoff();
                    setIsLoading(false);
                    return;
                  }

                  const zipCodeResponse = await fetch(`/api/allowed-zip?id=${new Date().valueOf()}&zipCode=${zipCode}`)
                  const zipCodes = await zipCodeResponse.json()
                  const isOutOfServiceArea = !zipCodes.isAllowed
                  if (isOutOfServiceArea) {
                    window.scrollTo(0, 0);
                    clearHeaderHandoff();
                    onNext(true, {
                      ...{
                        personName: savedName,
                        phone: formatPhoneNumber(savedPhone),
                        address: formatted,
                        locationData: { lat, lng }
                      },
                      isOutOfServiceArea: isOutOfServiceArea
                    });
                    document.getElementById("loadButton")?.classList.remove("loading");
                    setTimeout(() => {
                      (document.getElementById("loadButton") || {}).disabled = false;
                    }, 3000);
                    return;
                  }
                  setFormData({
                    personName: savedName,
                    phone: formatPhoneNumber(savedPhone),
                    address: formatted,
                    locationData: { lat, lng }
                  });
                  setInputValue(formatted);
                  const selectedLocation = {
                    lat: location.lat(),
                    lng: location.lng(),
                  };
                  const selectedAddress = {
                    address: formatted,
                    location: selectedLocation,
                    personName: savedName,
                    phone: savedPhone,
                    // The local from this geocode, NOT inputZipCodeValue:
                    // this closure runs once on load with the first-render
                    // state snapshot, so the state variable is always ""
                    // here even after setInputZipCodeValue above. The ZIP
                    // only ever reached the backend embedded in the
                    // formatted string; this field was silently empty.
                    zipCode: zipCode
                  };
                  // Split test assignment (bounded wait, fails open). The
                  // direct arm never calls draft-save.
                  const splitAssignment = await assignSplitTest(formatted, zipCode, selectedLocation);
                  if (splitAssignment) selectedAddress.splitAssignment = splitAssignment;
                  window.scrollTo(0, 0);
                  clearHeaderHandoff();
                  if (splitAssignment?.arm !== 'direct') {
                    const { splitAssignment: _split, ...draftAddress } = selectedAddress;
                    updateDraftRequest({
                      contactId: 'FROM PRICING',
                      ...draftAddress,
                      split_assignment_id: splitAssignment?.assignment_id,
                    })
                  }
                  onNext(true, selectedAddress);
                } else {
                  // Geocode failed (ZERO_RESULTS, quota, network). Without
                  // this branch the spinner never clears and the header
                  // user is stuck on a blank loader. localStorage is left
                  // intact on purpose: nothing was consumed, so a reload
                  // retries the handoff.
                  //
                  // Keep what the customer already typed into the header
                  // form: name and phone go straight into the form, and
                  // their address text lands in the input for correction.
                  // No geometry was established, so validation still
                  // requires a fresh dropdown selection before the form is
                  // submittable; only the address needs re-entry, not
                  // everything.
                  const savedName = localStorage.getItem('name') || '';
                  const savedPhone = localStorage.getItem('phone') || '';
                  setFormData((prev) => ({
                    ...prev,
                    personName: savedName,
                    phone: formatPhoneNumber(savedPhone),
                  }));
                  // The address input is uncontrolled (defaultValue only
                  // reads formData.address at mount, and the form is
                  // CSS-hidden while loading, not unmounted), so state
                  // alone never reaches the visible field. Write the DOM
                  // value through the ref, the same way the Places widget
                  // populates it on a selection; setInputValue keeps the
                  // label float and styling classes in agreement.
                  if (inputRef.current) {
                    inputRef.current.value = address;
                  }
                  setInputValue(address);
                  setIsLoading(false);
                }
              });
            }
          }); // Check every 100ms
          return () => clearInterval(intervalId);
        }
      } else {
        setIsLoading(false);
      }
    }
    if (document.readyState === 'complete') {
      handleWindowLoad();
    } else {
      window.addEventListener('load', handleWindowLoad);
      return () => window.removeEventListener('load', handleWindowLoad);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [serviceAreaMessage, setServiceAreaMessage] = useState("We'll confirm you're in our service area");

  const mapRef = useRef(null);
  const placeRef = useRef(null);
  const inputRef = useRef(null);
  const nameInputRef = useRef(null);
  const phoneInputRef = useRef(null);
  useEffect(() => {
    const { personName, phone, locationData } = formData;
    const isNameValid = !personName || /^\b[a-zA-Z'-]{2,}\b \b[a-zA-Z'-]{2,}\b/.test(personName);
    const isPhoneValid = !phone || /^(\+?\d{1,3}[\s.-]?)?(\(?\d{3}\)?[\s.-]?)?\d{3}[\s.-]?\d{4}$/.test(phone); // eslint-disable-line no-useless-escape
    const islocationDataValid = locationData;
    // The ZIP is the service-area routing key; without it the lead cannot
    // be priced or assigned a region downstream. It normally arrives with
    // the Places selection, so this only bites when the manual field is
    // showing (route-level selection).
    const isZipValid = /^\d{5}$/.test(inputZipCodeValue || "");

    setIsFormValid(personName && phone && isNameValid && isPhoneValid && islocationDataValid && isZipValid);

    setErrors({
      personName: personName && !isNameValid ? "Please enter your first and last name" : "",
      locationData: !islocationDataValid ? "Please select an address from the dropdown" : "",
      personPhone: phone && !isPhoneValid ? "Please enter a valid 10-digit phone number" : "",
      zipCode: zipMissingFromPlace && !isZipValid ? "Please enter your 5-digit ZIP code" : "",
    });
  }, [formData, inputZipCodeValue, zipMissingFromPlace]);

  useEffect(() => {
    if (!window.google) {
      return;
    }

    const mapElement = document.getElementById("map");
    if (!mapElement) {
      console.error("Map element with id 'map' not found.");
      return;
    }
    const map = new window.google.maps.Map(mapElement, {
      center: selectedLocation,
      zoom: 15,
      mapTypeId: "roadmap",
      fullscreenControl: false,
      gestureHandling: "none",
      zoomControl: false,
      keyboardShortcuts: false,
      styles: [
        {
          featureType: "all",
          elementType: "all",
          stylers: [{ saturation: -100 }, { visibility: "simplified" }],
        },
        {
          featureType: "poi",
          elementType: "labels",
          stylers: [{ visibility: "off" }],
        },
      ],
    });

    new window.google.maps.Marker({
      position: selectedLocation,
      map: map,
      icon: {
        url: "/images/pin_icon.svg",
      },
    });


  }, [selectedLocation]);

  useEffect(() => {
    setContactId('');
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  // Update service area message based on inputValue  
  useEffect(() => {
    if (inputValue.includes("San Diego")) {
      setServiceAreaMessage("Great, you're in our service area. Let's get you a quote.");
    }
  }, [inputValue]);

  const handleButtonClick = (e) => {
    const { personName, phone } = formData;

    const isNameValid = personName && /^\b[a-zA-Z'-]{2,}\b \b[a-zA-Z'-]{2,}\b/.test(personName);
    const isPhoneValid = phone && /^(\+?\d{1,3}[\s.-]?)?(\(?\d{3}\)?[\s.-]?)?\d{3}[\s.-]?\d{4}$/.test(phone); // eslint-disable-line no-useless-escape

    const newErrors = {};
    if (!personName) {
      newErrors.personName = "Please enter your first and last name";
    } else if (!isNameValid) {
      newErrors.personName = "Please enter your first and last name";
    }

    if (!phone) {
      newErrors.personPhone = "Please enter a valid 10-digit phone number";
    } else if (!isPhoneValid) {
      newErrors.personPhone = "Please enter a valid 10-digit phone number";
    }

    if (Object.keys(newErrors).length > 0) {
      e.preventDefault();
      setErrors((prevErrors) => ({ ...prevErrors, ...newErrors }));
      setShowErrors(true);
    }
  };

  const handlePlaceSelected = (place) => {
    placeRef.current = place?.geometry && place?.geometry?.location ? place : null;
    if (place?.geometry && place?.geometry?.location) {
      setInputValue(place?.formatted_address);
      // A Places result with geometry is not necessarily a complete street
      // address: route- and city-level suggestions ("CA-91, Anaheim, CA")
      // have geometry but no postal_code component, and geocoding cannot
      // recover one (a route spans multiple ZIPs). When that happens the
      // ZIP field below un-hides and the user supplies it; treating the
      // selection as complete here is what used to send ZIP-less leads
      // that could never be routed to a service region.
      const zipComponent = (place.address_components || []).find(
        (x) => (x.types || []).includes('postal_code')
      );
      // Normalize before deciding visibility: a postal_code component whose
      // value does not contain a 5-digit ZIP (empty, malformed) must count
      // as missing, or the manual field stays hidden while validation fails
      // and the form is permanently disabled.
      const normalizedZip = zipComponent?.long_name?.match(/\b\d{5}\b/)?.[0] || "";
      setInputZipCodeValue(normalizedZip);
      // Gate the manual-ZIP field on the normalized place result, not on
      // inputZipCodeValue: keying the render on the value would unmount the
      // field as soon as the user types the first digit into it.
      setZipMissingFromPlace(!normalizedZip);
      setSelectedLocation({
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      });
      setIsValidAddress(true);
    } else {
      setInputValue("");
      setInputZipCodeValue("");
      setIsValidAddress(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;
    if (name === "phone") {
      updatedValue = formatPhoneNumber(value);
    }
    if (name && value) {
      if (name === "locationData") {
        setInputValue(updatedValue);
        setSelectedLocation(center);
        setIsValidAddress(false);
      }
    }
    setFormData({
      ...formData,
      [name]: updatedValue,
    });
  };

  const isValidLocation =
    selectedLocation.lat !== 0 && selectedLocation.lng !== 0;

  // Direct vs Cabana split test. Resolves to the assignment or null; never
  // throws and never waits longer than the split-assign timeout.
  const assignSplitTest = async (formatted, zip, location) => {
    const address = splitAddressFromPlace(placeRef.current, {
      formatted, zip, lat: location?.lat, lng: location?.lng,
    });
    const forced = Boolean(eastBayBrand(address.zip || zip));
    const assignment = await requestSplitAssignment({
      address,
      stableId: getStatsigStableId(),
      quoteSession: getQuoteSession(),
      enabled: forced || undefined,
    });
    if (assignment?.arm === 'direct') return assignment;
    if (!forced) return assignment;
    const fallback = eastBayFallbackAssignment(address.zip || zip);
    publishSplitAssignment(fallback);
    return fallback;
  };
  
  const updateDraftRequest = updatedFormData => {
    if (updatedFormData.personName) {
      updatedFormData.personFirstName = updatedFormData.personName?.split(' ')[0]
      updatedFormData.personLastName = updatedFormData.personName?.split(' ')[1]
    }
    try {
      fetch(
        "/api/draft-save",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedFormData),
        }
      ).then(res => res.json()).then(res => {
        console.log(res)
      });
    } catch (error) {

    }
  }

  const getServiceByPhone = async () => {
  try {
    const phoneNumber = {
      phone: formData.phone
    }
    const res = await fetch("/api/recent-by-phone", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(phoneNumber),
    });

    const data = await res.json();

    if (data?.success) {
      setIsPhoneNumberExist(true);
      return true;
    } else {
      setIsPhoneNumberExist(false);
      return false;
    }
    } catch (error) {
      setIsPhoneNumberExist(false);
      return false;
    }
  }

  return (
    <>
      <div className={`${!isLoading ? 'display-none' : ''}`} style={styles.overlay}>
        <div style={styles.loader}>
          <div style={styles.ring}></div>
          <img
            src="/plfavicon.png"
            alt="Loading..."
            style={styles.icon}
          />
        </div>
      </div>
      <div className={`form-container ${isLoading ? 'display-none' : ''}`}>
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            if (isFormValid) {
              document.getElementById('loadButton')?.classList.add('loading');
              (document.getElementById('loadButton') || {}).disabled = true;
              formData.personName.split(' ').slice(0, -1).join(' ');
              formData.personName.split(' ').slice(-1).join(' ');
              const requestObj = {
                contact_id: getContactId(),
                personName: formData.personName,
                phone: formData.phone,
                address: inputValue
              }
              AdsKeys.forEach(item => {
                if (localStorage.getItem(item)) {
                  requestObj[item] = localStorage.getItem(item);
                }
              })
              let isOutOfServiceArea = false;
              const selectedAddress = {
                address: inputValue,
                location: selectedLocation,
                personName: formData.personName,
                phone: formData.phone,
                zipCode: inputZipCodeValue,
                isOutOfServiceArea: isOutOfServiceArea
              };
              if (inputZipCodeValue) {
                const zipCodeResponse = await fetch(`/api/allowed-zip?id=${new Date().valueOf()}&zipCode=${inputZipCodeValue}`)
                const zipCodes = await zipCodeResponse.json()
                isOutOfServiceArea = !zipCodes.isAllowed
              } else {
                // Unreachable since isFormValid requires a 5-digit ZIP
                // (route-level selections surface the manual ZIP field
                // instead of arriving here empty). Kept as a fail-safe;
                // a lead we cannot area-check goes to the out-of-area
                // review flow rather than being priced blind.
                isOutOfServiceArea = true;
              }
              if (isOutOfServiceArea) {
                window.scrollTo(0, 0);
                // A failed-geocode handoff leaves its keys for a reload
                // retry; the customer advancing manually supersedes it, so
                // consume them here like every auto-consumed path does, or
                // the next visit replays the stale handoff.
                clearHeaderHandoff();
                onNext(true, {
                  ...selectedAddress,
                  isOutOfServiceArea: isOutOfServiceArea
                });
                document.getElementById("loadButton")?.classList.remove("loading");
                setTimeout(() => {
                  (document.getElementById("loadButton") || {}).disabled = false;
                }, 3000);
                return;
              } else {
                // window.scrollTo(0, 0);
                // onNext(true, selectedAddress);
                // document.getElementById("loadButton")?.classList.remove("loading");
                // (document.getElementById("loadButton") || {}).disabled = false;
                // return;
              }
              const isExist = await getServiceByPhone();
              if (isExist) {
                document.getElementById("loadButton")?.classList.remove("loading");
                (document.getElementById("loadButton") || {}).disabled = false;
                return;
              }
              // Split test assignment, after the zip check passed (bounded
              // wait, fails open to the normal funnel). The direct arm never
              // calls draft-save.
              const splitAssignment = await assignSplitTest(inputValue, inputZipCodeValue, selectedLocation);
              const isDirectArm = splitAssignment?.arm === 'direct';
              if (splitAssignment) selectedAddress.splitAssignment = splitAssignment;
              const payload = JSON.stringify(requestObj);
              fetch("/api/contact-id", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: payload,
              })
                .then((response) => {
                  if (!response.ok) {
                    throw new Error("Network response was not ok");
                  }
                  return response.json();
                })
                .then((data) => {
                  if (data.status === "success") {
                    setContactId(data.contactId);
                    if (!isDirectArm) {
                      updateDraftRequest({
                        contactId: data.contactId,
                        personName: formData.personName,
                        phone: formData.phone,
                        address: inputValue,
                        zipCode: inputZipCodeValue,
                        split_assignment_id: splitAssignment?.assignment_id,
                      })
                    }
                    document.getElementById("loadButton")?.classList.remove("loading");
                    setTimeout(() => {
                      (document.getElementById("loadButton") || {}).disabled = false;
                    }, 3000);
                  } else {
                    sendEmail("Error occured in /api/contact-id", {
                      error: data,
                      request: payload
                    })
                    document.getElementById("loadButton")?.classList.remove("loading");
                    setTimeout(() => {
                      (document.getElementById("loadButton") || {}).disabled = false;
                    }, 3000);
                    throw new Error(data.message || "Failed to create contact");
                  }
                })
                .catch((error) => {
                  console.error("There was an error:", error);
                  sendEmail("Error occured in /api/contact-id", {
                    error: error,
                    request: payload
                  })
                });

              window.scrollTo(0, 0);
              // Same consumption as the out-of-area branch above: a manual
              // advance supersedes any unconsumed header handoff.
              clearHeaderHandoff();
              onNext(true, selectedAddress);
            }
          }}
        >
          <input type="hidden" name="ga4_id" id="ga4_id" defaultValue={window.ga4_id} />
          <div className="step-section">
            <h1>Let’s start with your address</h1>
            <p className="service area">{serviceAreaMessage}</p>
          </div>
          {isValidAddress && inputValue.length > 10 && isValidLocation && (
            <div className="row">
              <div className="map-container-parent col-md-12">
                <div
                  className="map_container"
                  id="map"
                  ref={mapRef}
                  style={{ height: "150px", width: "100%" }}
                ></div>
              </div>
            </div>
          )}

          <div className="field-mini-wrap">
            <div className="row">
              <div className="col-md-12">
                <div className="input-container form-floating mt-5 position-relative">
                  <IoLocationOutline className="icon" />
                  <Autocomplete
                    ref={inputRef}
                    className={`form-control input-field street-field  ${inputValue ? "has-content" : ""
                      } ${!isValidAddress && inputValue !== "" && !isValidLocation
                        ? "i-cant-found"
                        : ""
                      }`}
                    apiKey="AIzaSyBOFtdyj-O0-376jIqBPEAuSP2zweByuVk"
                    options={{
                      types: ["address"],
                      componentRestrictions: { country: "us" },
                    }}
                    onPlaceSelected={handlePlaceSelected}
                    onChange={handleInputChange}
                    defaultValue={formData.address}
                    aria-invalid={!!errors.locationData}
                    name="locationData"
                  />
                  <label
                    htmlFor="form-name"
                    className={`address ${inputValue ? `street-address` : ""}`}
                  >
                    Street address
                  </label>
                  {!isValidAddress && inputValue !== "" && !isValidLocation && (
                    <div className="address-no-results">
                      <Link to={withPreviewBrand("/step/2")}>I can't find my address</Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {isValidAddress && isValidLocation && inputValue && zipMissingFromPlace && (
              <div className="row">
                <div className="col-md-6">
                  <div className="input-container form-floating position-relative input-box">
                    <input
                      className={`form-control input-field pac-target-input ${showErrors && errors.zipCode ? "invalid-field" : ""
                        }`}
                      placeholder="ZIP code"
                      name="zipCode"
                      id="zipCode"
                      type="text"
                      inputMode="numeric"
                      maxLength={5}
                      value={inputZipCodeValue}
                      autoFocus
                      onChange={(e) => {
                        setInputZipCodeValue(e.target.value.replace(/\D/g, "").slice(0, 5));
                        if (showErrors) setShowErrors(false);
                      }}
                      aria-invalid={showErrors && !!errors.zipCode}
                    />
                    <label htmlFor="zipCode">ZIP code (to check service availability)</label>
                  </div>
                  {showErrors && errors.zipCode && (
                    <div className="field-error-message">{errors.zipCode}</div>
                  )}
                </div>
              </div>
            )}
            {isValidAddress && isValidLocation && inputValue && (
              <div className="row">
                <div className="col-md-6">
                  <div className="input-container form-floating position-relative input-box">
                    <input
                      className={`form-control input-field pac-target-input ${showErrors && errors.personName ? "invalid-field" : ""
                        }`}
                      placeholder="Enter a name"
                      name="personName"
                      value={formData.personName}
                      ref={nameInputRef}
                      id="personName"
                      pattern="[a-zA-Z\s'-]{2,}"
                      aria-invalid={showErrors && !!errors.personName}
                      onChange={(e) => {
                        handleInputChange(e);
                        if (showErrors) setShowErrors(false);
                      }}
                    />
                    <label htmlFor="personName">First and last name</label>
                  </div>
                  {showErrors && errors.personName && (
                    <div className="field-error-message">{errors.personName}</div>
                  )}
                </div>
                <div className="col-md-6">
                  <div className="input-container form-floating position-relative input-box">
                    <input
                      className={`form-control input-field pac-target-input ${showErrors && errors.personPhone ? "invalid-field" : ""
                        }`}
                      placeholder="Phone (123-123-1234)"
                      name="phone"
                      id="phone"
                      type="text"
                      value={formData.phone}
                      ref={phoneInputRef}
                      onChange={(e) => {
                        handleInputChange(e);
                        if (showErrors) setShowErrors(false);
                      }}
                      aria-invalid={showErrors && !!errors.personPhone}
                      inputMode="numeric"
                      required
                    />
                    <label htmlFor="phone">Phone number</label>
                  </div>
                  {showErrors && errors.personPhone && (
                    <div className="field-error-message">{errors.personPhone}</div>
                  )}
                </div>
              </div>
            )}
          </div>
          {<div className="lock-bg">
            <FaLock className="lock-color" />
            <span className="from-lock">Your information is fully secure.</span>
          </div>}
          <button
            type="submit"
            className={`btn ${!isValidAddress && inputValue !== "" && !isValidLocation
              ? "next-btn"
              : "setp-next-btn"
              }  
          ${(!isFormValid || isPhoneNumberExist)
                ? "button-disabled"
                : ""
              }  
          `}
            onClick={handleButtonClick}
            id="loadButton"
            data-cta-copy={step1CtaCopy}
          >
            {step1CtaCopy}
          </button>
          <input type="hidden" id="progress_slide_1" data-width="20%" />
          <input type="hidden" id="contact_id" />
          <div className="under-button-text">By continuing, you are agreeing to receive text messages from Cabana.<div></div>Message and data rates may apply, and the frequency of messages may vary.<br />You may opt out at any time.</div>
        </form>
      </div>
      <Modal isOpen={isPhoneNumberExist} onClose={() => setIsPhoneNumberExist(false)}>
        <div style={{
            textAlign: 'center',
          }}>
          <img src={"/images/thank-you.svg"} alt="G1" className="radius-border image-center" />
        </div>
        <h4 style={{
            textAlign: 'center',
          }}>We've received your quote request and will be calling you shortly to confirm details and get your pool sparkling. If you have questions or edits you want to make, just give us a call. Either way, we'll talk to you soon!</h4>
      </Modal>
    </>
  );
};

export default Slide1;
